<template>
<div id="article-container">
    <section class='movie'>
        <h1 class="title">豆瓣电影Top 250</h1>
        <div class="sider-bar">
            <button @click='nextPage(0)'>Top 10</button>
            <button herf='javascript:' @click='nextPage(-1)' :disabled='disable'>Prev</button>
            <button herf='javascript:' @click='nextPage(1)'>Next</button>
        </div>
        <div class="main-content">
            <div class="spinner" v-if="isLoading">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
            <div class="articel-list" v-show="!isLoading">
                <h2 v-text="title"></h2>
                <ul class="aList">
                    <li v-for="article in articles">
                        <a :href='article.alt' v-text="article.title">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>

</div>
</template>

<script>
export default {
    data() {
        return {
            articles: [],
            title: '',
            isLoading: true,
            disable: true
        }
    },
    methods: {
        nextPage(status) {
            this.isLoading = true;
            if (status == 0) {
                this.page = 0
            } else if (status == 1) {
                this.page = this.page < 25 ? ++this.page : 25;
            } else {
                this.page = this.page > 0 ? this.page - 1 : 0;
            }
            this.disable = this.page > 0 && this.page < 25 ? false : true;
            let start = this.page * 10;

            this.$http.jsonp('https://api.douban.com/v2/movie/top250?count=10&start=' + start, {}, {
                headers: {},
                emulateJSON: true
            }).then(function(response) {
                // 这里是处理正确的回调
                console.log(response);
                this.articles = response.data.subjects
                // this.title = response.data.title;
                this.isLoading = false;
            }, function(response) {
                // 这里是处理错误的回调
                console.log(response)
            });
        }
    },
    mounted() {
        this.nextPage(0);
        let x = {
            y: 123
        }
        let {
            x: o
        } = {
            x
        }
        console.log(o);
        console.log(this.$route)

    },


}
</script>
<style lang='scss'>
.spinner {
    margin: 100px auto;
    width: 40px;
    height: 40px;
    position: relative;
    text-align: center;

    -webkit-animation: sk-rotate 2.0s infinite linear;
    animation: sk-rotate 2.0s infinite linear;
}

.dot1,
.dot2 {
    width: 60%;
    height: 60%;
    display: inline-block;
    position: absolute;
    top: 0;
    background-color: #42b983;
    border-radius: 100%;

    -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
    animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
    top: auto;
    bottom: 0;
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}
@-webkit-keyframes sk-rotate {
    100% {
        -webkit-transform: rotate(360deg);
    }
}
@keyframes sk-rotate {
    100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
    }
}
@-webkit-keyframes sk-bounce {
    0%,
    100% {
        -webkit-transform: scale(0.0);
    }
    50% {
        -webkit-transform: scale(1.0);
    }
}
@keyframes sk-bounce {
    0%,
    100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    }
    50% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
    }
}
</style>



// WEBPACK FOOTER //
// doubanTop250.vue?f5e0e390